import api from './api';
import { IBetaFeedback, FeedbackCategory, FeedbackStatus } from '../types/betaFeedback';

export const submitFeedback = async (
  category: FeedbackCategory,
  description: string,
  attachments?: File[]
): Promise<{ message: string; feedback: Partial<IBetaFeedback> }> => {
  const formData = new FormData();
  formData.append('category', category);
  formData.append('description', description);

  if (attachments && attachments.length > 0) {
    attachments.forEach((file) => {
      formData.append('attachments', file);
    });
  }

  const response = await api.post<{ message: string; feedback: Partial<IBetaFeedback> }>(
    '/beta-feedback',
    formData
  );
  return response.data;
};

export const getMyFeedback = async (): Promise<{
  feedback: IBetaFeedback[];
  total: number;
}> => {
  const response = await api.get<{ feedback: IBetaFeedback[]; total: number }>(
    '/beta-feedback/mine'
  );
  return response.data;
};

export const getAllFeedback = async (params?: {
  category?: FeedbackCategory;
  status?: FeedbackStatus;
  page?: number;
  limit?: number;
}): Promise<{
  feedback: IBetaFeedback[];
  total: number;
  page: number;
  pages: number;
}> => {
  const query: Record<string, string> = {};
  if (params?.category) query.category = params.category;
  if (params?.status) query.status = params.status;
  if (params?.page !== undefined) query.page = String(params.page);
  if (params?.limit !== undefined) query.limit = String(params.limit);

  const response = await api.get('/beta-feedback', { params: query });
  return response.data;
};

export const updateFeedbackStatus = async (
  id: string,
  status: FeedbackStatus,
  adminNotes?: string
): Promise<{ message: string; feedback: IBetaFeedback }> => {
  const response = await api.patch<{ message: string; feedback: IBetaFeedback }>(
    `/beta-feedback/${id}`,
    { status, adminNotes }
  );
  return response.data;
};
